<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5996 4.24219C11.8251 4.2704 12 4.4631 12 4.69629V7.2832L11.9961 7.34082C11.9678 7.56636 11.7752 7.74119 11.542 7.74121L11.4853 7.7373C11.2598 7.7091 11.0849 7.51639 11.085 7.2832V5.91504L8.47265 8.52832L8.46874 8.52441C8.24505 8.74255 7.8883 8.74182 7.66698 8.52051C7.44405 8.29756 7.44398 7.93622 7.66698 7.71289C7.67016 7.70972 7.6745 7.70718 7.67773 7.7041L10.2295 5.15332H8.95507L8.89745 5.15039C8.67202 5.1221 8.49804 4.92939 8.49804 4.69629C8.49806 4.44369 8.70248 4.23931 8.95507 4.23926L11.543 4.23828L11.5996 4.24219Z"
      fill="#2F4051"
    />
    <path
      d="M5 5V9.5C5 10.3284 5.67157 11 6.5 11H11M5 5V3.5C5 2.67157 5.67157 2 6.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.3284 13.3284 11 12.5 11H11M5 5H3.5C2.67157 5 2 5.67157 2 6.5V12.5C2 13.3284 2.67157 14 3.5 14H9.5C10.3284 14 11 13.3284 11 12.5V11"
      stroke="#2F4051"
      stroke-width="1.25"
    />
  </svg>
</template>

<script>
export default {
  name: 'PopupIcon'
};
</script>
